export const DARK_GREY = "#292D30";

export const PRIMARY_COLOR_100 = "#B96666";
export const PRIMARY_COLOR_200 = "#AE4D4D";
export const PRIMARY_COLOR_300 = "#A23333";
export const PRIMARY_COLOR_400 = "#971919";
export const PRIMARY_COLOR_500 = "#8B0000";
export const PRIMARY_COLOR_600 = "#760000";
export const PRIMARY_COLOR_700 = "#680000";
export const PRIMARY_COLOR_800 = "#5A0000";
export const PRIMARY_COLOR_900 = "#4C0000";